import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function SubBotBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({

    isElementEditable: true,
    editElementModalController: 'editSubBotBoxController',
    editElementModalTemplate: require('./editSubBotBox.modal.html'),

    angularTemplate: `
<div layout="column">
  <span>{{ elementData.subBotDescription.description }}</span>
</div>
`,

    // If the edition dialogs passed some exits, let's remove the exising exits and create new ones
    afterEditElement: function () {
      if (this.angularScope.elementData.exits) {
        let currentExits = this.model.getEmbeddedCells();
        currentExits.filter(exitCell => exitCell.get('elementData').exitType !== 'failure')
          .forEach(exitCell => exitCell.remove());
        const newExits = this.angularScope.elementData.exits;
        services.QuickRepliesFactory.createUniqueIds(context.companyId, context.site.id, context.scenarioId, newExits.length)
          .then(response => {
            const ids = response.data.map(element => element.id);
            let index = 0;
            newExits.forEach(exitDescription => {
              const exitElementData = {
                exitType: 'success',
                name: exitDescription.name,
                description: exitDescription.description
              };
              const exit = this.createExit(ids[index++], TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, exitElementData);
              this.model.graph.addCell(exit);
            });
            if (this.reorderChildren) {
              this.reorderChildren();
            }
          },
            services.AlertingFactory.httpErrorHandler()
          );

        delete this.angularScope.elementData.exits; // no need to serialize the exits in theit parents' elementData as they have their own graph elements
      }
    },


    createExit: function (id, position, size, elementData) {
      const exit = new joint.shapes.html.SubBotExit({ id, position, size, elementData });
      this.model.embed(exit);
      return exit;
    },

    isChildAlwaysLast: function (child) {
      return child.get('elementData')?.exitType === 'failure';
    },
  });
}
